import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
// const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/ModifiedLoginPage')));
// const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
const ResetPassword = Loadable(lazy(() => import('views/pages/authentication/auth-forms/forgotPassword')));
const ResetPassword2 = Loadable(lazy(() => import('views/pages/authentication/auth-forms/ForgotPassword2')));
const LoginFromRedirect = Loadable(lazy(() => import('views/pages/authentication/authentication3/LoginFromRedirect')));
const Unauthorized = Loadable(lazy(() => import('views/pages/authentication/authentication3/UnauthorizedPage')));
const MpinCreation = Loadable(lazy(() => import('views/pages/authentication/M-pin/Mpin')));
const BcAgreeSuccessRedirect = Loadable(lazy(() => import('views/Components/BcAgreementSuccessPage')));
const BcAgreeCancelRedirect = Loadable(lazy(() => import('views/Components/BcAgreementCancelPage')));
const SelfSignup = Loadable(lazy(() => import('views/pages/authentication/selfSignup/SelfSignup')));
const CreateAccount = Loadable(lazy(() => import('views/pages/authentication/selfSignup/CreateAccount')));
const CmsSelfSignup = Loadable(lazy(() => import('modules/cmsSelfSignup/pages/CmsSelfSignupWizard')));
const MarketPlaceServices = Loadable(lazy(() => import('views/Others/marketPlace/MarketPlaceServices')));
const AddNewMarketPlaceEntry = Loadable(lazy(() => import('views/Others/marketPlace/AddNewEntry')));
// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/',
            element: <AuthLogin3 />
        },
        {
            path: '/self-signup',
            element: <SelfSignup />
        },
        {
            path: '/Selfsignup/Verification',
            element: <CreateAccount />
        },
        {
            path: '/cms-self-signup',
            element: <CmsSelfSignup />
        },
        {
            path: '/resetpassword',
            element: <ResetPassword />
        },
        {
            path: '/resetpassword2',
            element: <ResetPassword2 />
        },
        {
            path: '/loginfromredirect',
            element: <LoginFromRedirect />
        },
        {
            path: '/unauthorized',
            element: <Unauthorized />
        },
        {
            path: '/mpin',
            element: <MpinCreation />
        },
        {
            path: '/bcAgreeSuccess',
            element: <BcAgreeSuccessRedirect />
        },
        {
            path: '/bcAgreeCancel',
            element: <BcAgreeCancelRedirect />
        },
        {
            path: 'marketplace-mobile',
            children: [
                {
                    path: 'services',
                    element: <MarketPlaceServices />
                },
                {
                    path: 'addNewCustomerEntry',
                    element: <AddNewMarketPlaceEntry />
                }
            ]
        }
    ]
};

export default AuthenticationRoutes;
